export default __webpack_public_path__ + "static/img-asaas--mobile-1638b12474427d75cb1ac4d4f4db56f2.png";